var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c("a-modal", {
    staticClass: "lang-modal",
    attrs: {
      title: (_vm.isEdit ? _vm.$t("编辑") : _vm.$t("添加")) + _vm.$t("货币"),
      visible: _vm.visible,
      width: 600
    },
    on: {
      cancel: e => _vm.closeAddVisible(e)
    }
  }, [_c("a-form-model", {
    ref: "addFormRef",
    attrs: {
      model: _vm.addForm,
      rules: _vm.ADD_RULES,
      "label-col": {
        span: 5
      },
      "wrapper-col": {
        span: 16
      }
    }
  }, [_c("a-form-model-item", {
    attrs: {
      label: _vm.$t("货币代码"),
      prop: "code"
    }
  }, [_c("a-input", {
    attrs: {
      disabled: _vm.isEdit ? true : false,
      allowClear: ""
    },
    model: {
      value: _vm.addForm.code,
      callback: function ($$v) {
        _vm.$set(_vm.addForm, "code", typeof $$v === "string" ? $$v.trim() : $$v);
      },
      expression: "addForm.code"
    }
  })], 1), _c("a-form-model-item", {
    attrs: {
      label: _vm.$t("货币名称"),
      prop: "name"
    }
  }, [_c("a-input", {
    attrs: {
      disabled: _vm.isEdit ? true : false,
      allowClear: ""
    },
    model: {
      value: _vm.addForm.name,
      callback: function ($$v) {
        _vm.$set(_vm.addForm, "name", typeof $$v === "string" ? $$v.trim() : $$v);
      },
      expression: "addForm.name"
    }
  })], 1), _c("a-form-model-item", {
    attrs: {
      label: _vm.$t("货币单位"),
      prop: "unit"
    }
  }, [_c("a-input", {
    attrs: {
      disabled: _vm.isEdit ? true : false,
      allowClear: ""
    },
    model: {
      value: _vm.addForm.unit,
      callback: function ($$v) {
        _vm.$set(_vm.addForm, "unit", typeof $$v === "string" ? $$v.trim() : $$v);
      },
      expression: "addForm.unit"
    }
  })], 1), _c("a-form-model-item", {
    attrs: {
      label: _vm.$t("货币符号"),
      prop: "symbol"
    }
  }, [_c("a-select", {
    staticStyle: {
      width: "100px"
    },
    attrs: {
      disabled: _vm.isEdit ? true : false,
      getPopupContainer: triggerNode => triggerNode.parentNode
    },
    on: {
      change: _vm.exampleBuilder
    },
    model: {
      value: _vm.addForm.position,
      callback: function ($$v) {
        _vm.$set(_vm.addForm, "position", $$v);
      },
      expression: "addForm.position"
    }
  }, [_c("a-select-option", {
    attrs: {
      value: "left"
    }
  }, [_vm._v(_vm._s(_vm.$t("左侧")))]), _c("a-select-option", {
    attrs: {
      value: "right"
    }
  }, [_vm._v(_vm._s(_vm.$t("右侧")))])], 1), _c("a-input", {
    staticStyle: {
      width: "calc(100% - 240px)",
      margin: "0 10px"
    },
    attrs: {
      disabled: _vm.isEdit ? true : false,
      allowClear: ""
    },
    on: {
      change: _vm.exampleBuilder
    },
    model: {
      value: _vm.addForm.symbol,
      callback: function ($$v) {
        _vm.$set(_vm.addForm, "symbol", $$v);
      },
      expression: "addForm.symbol"
    }
  }), _c("a-checkbox", {
    staticStyle: {
      width: "120px"
    },
    attrs: {
      disabled: _vm.isEdit ? true : false
    },
    on: {
      change: _vm.exampleBuilder
    },
    model: {
      value: _vm.addForm.useSpaces,
      callback: function ($$v) {
        _vm.$set(_vm.addForm, "useSpaces", $$v);
      },
      expression: "addForm.useSpaces"
    }
  }, [_vm._v(" " + _vm._s(_vm.$t("使用空格")) + " ")])], 1), _c("a-form-model-item", {
    attrs: {
      label: _vm.$t("金额精度"),
      prop: "amountAccuracy"
    }
  }, [_c("a-select", {
    attrs: {
      disabled: "",
      getPopupContainer: triggerNode => triggerNode.parentNode
    },
    on: {
      change: e => (_vm.addForm.unitAccuracy = e, _vm.exampleBuilder())
    },
    model: {
      value: _vm.addForm.amountAccuracy,
      callback: function ($$v) {
        _vm.$set(_vm.addForm, "amountAccuracy", $$v);
      },
      expression: "addForm.amountAccuracy"
    }
  }, _vm._l([0, 1, 2, 3, 4, 5, 6], function (item) {
    return _c("a-select-option", {
      key: item,
      attrs: {
        value: item
      }
    }, [_vm._v(_vm._s(item))]);
  }), 1)], 1), _c("a-form-model-item", {
    attrs: {
      label: _vm.$t("单位精度"),
      prop: "unitAccuracy"
    }
  }, [_c("a-input", {
    attrs: {
      disabled: ""
    },
    model: {
      value: _vm.addForm.unitAccuracy,
      callback: function ($$v) {
        _vm.$set(_vm.addForm, "unitAccuracy", typeof $$v === "string" ? $$v.trim() : $$v);
      },
      expression: "addForm.unitAccuracy"
    }
  })], 1), _c("a-form-model-item", {
    attrs: {
      label: _vm.$t("分隔符"),
      prop: "delimiter"
    }
  }, [_c("a-select", {
    staticStyle: {
      width: "calc(100% - 220px)"
    },
    attrs: {
      getPopupContainer: triggerNode => triggerNode.parentNode
    },
    on: {
      change: _vm.exampleBuilder
    },
    model: {
      value: _vm.addForm.separator,
      callback: function ($$v) {
        _vm.$set(_vm.addForm, "separator", $$v);
      },
      expression: "addForm.separator"
    }
  }, [_c("a-select-option", {
    attrs: {
      value: "hundred"
    }
  }, [_vm._v(_vm._s(_vm.$t("百位")))]), _c("a-select-option", {
    attrs: {
      value: "thousand"
    }
  }, [_vm._v(_vm._s(_vm.$t("千位")))])], 1), _c("a-select", {
    staticStyle: {
      width: "100px",
      margin: "0 10px"
    },
    attrs: {
      allowClear: "",
      disabled: _vm.addForm.isUse,
      getPopupContainer: triggerNode => triggerNode.parentNode
    },
    on: {
      change: function ($event) {
        _vm.$refs.addFormRef.validateField("delimiter"), _vm.exampleBuilder();
      }
    },
    model: {
      value: _vm.addForm.delimiter,
      callback: function ($$v) {
        _vm.$set(_vm.addForm, "delimiter", typeof $$v === "string" ? $$v.trim() : $$v);
      },
      expression: "addForm.delimiter"
    }
  }, [_c("a-select-option", {
    attrs: {
      value: ","
    }
  }, [_vm._v(_vm._s(_vm.$t(",")))]), _c("a-select-option", {
    attrs: {
      value: "."
    }
  }, [_vm._v(_vm._s(_vm.$t(".")))])], 1), _c("a-checkbox", {
    staticStyle: {
      width: "100px"
    },
    on: {
      change: _vm.changeUse
    },
    model: {
      value: _vm.addForm.isUse,
      callback: function ($$v) {
        _vm.$set(_vm.addForm, "isUse", $$v);
      },
      expression: "addForm.isUse"
    }
  }, [_vm._v(" " + _vm._s(_vm.$t("不使用")) + " ")])], 1), _c("a-form-model-item", {
    attrs: {
      label: _vm.$t("示例")
    }
  }, [_c("span", [_vm._v(_vm._s(_vm.addForm.showValue))])])], 1), _c("template", {
    slot: "footer"
  }, [_c("a-button", {
    attrs: {
      type: "primary",
      size: "small",
      loading: _vm.saveLoading,
      disabled: _vm.saveLoading
    },
    on: {
      click: _vm.saveAdd
    }
  }, [_vm._v(" " + _vm._s(_vm.saveLoading ? "" : _vm.$t("保存")) + " ")]), _c("a-button", {
    attrs: {
      size: "small"
    },
    on: {
      click: _vm.closeAddVisible
    }
  }, [_vm._v(" " + _vm._s(_vm.$t("取消")) + " ")])], 1)], 2);
};
var staticRenderFns = [];
render._withStripped = true;
export { render, staticRenderFns };